import React from 'react';

const MyBuyers = () => {
    return (
        <div>
            <h2 className='text-2xl text-slate-900'>My Buyers</h2>
            <h2 className='text-xs text-slate-900'>For Seller</h2>
        </div>
    );
};

export default MyBuyers;